/**
 * @generated SignedSource<<1f9be0af5fe3d8171a37c5def43a971c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type confluencePages_nativeIssueTable_ConfluencePagesCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "confluencePages_nativeIssueTable_ConfluencePagesCell";
};
export type confluencePages_nativeIssueTable_ConfluencePagesCell$key = {
  readonly " $data"?: confluencePages_nativeIssueTable_ConfluencePagesCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"confluencePages_nativeIssueTable_ConfluencePagesCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "confluencePages_nativeIssueTable_ConfluencePagesCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_ConfluencePagesInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
};

(node as any).hash = "0ec3d60cde87b4245ca941ac347b32b8";

export default node;
